import { Reference } from '@apollo/client';

import useMutationWithValidation from '@hooks/useMutationWithValidation';
import {
  GoalFragment,
  GoalItemRemoveDocument,
  GoalItemRemoveMutation,
  GoalItemRemoveMutationVariables
} from '@typing/Generated';

const useRemoveGoalItem = (goal: GoalFragment | null) => {
  const [removeGoalItem] = useMutationWithValidation<GoalItemRemoveMutation, GoalItemRemoveMutationVariables>(
    GoalItemRemoveDocument,
    'goal',
    {
      update: (store, { data }) => {
        if (data?.goalItemRemove?.articleId) {
          store.modify({
            fields: {
              articles(cachedArticleRefs: readonly Reference[], { readField }) {
                return cachedArticleRefs.filter(ref => data.goalItemRemove?.articleId !== readField('id', ref));
              }
            },
            id: store.identify({ __typename: 'Goal', id: goal?.id })
          });
        }
        if (data?.goalItemRemove?.employerBenefitId) {
          store.modify({
            fields: {
              employerBenefits(cachedEmployerBenefitRefs: readonly Reference[], { readField }) {
                return cachedEmployerBenefitRefs.filter(
                  ref => data.goalItemRemove?.employerBenefitId !== readField('id', ref)
                );
              }
            },
            id: store.identify({ __typename: 'Goal', id: goal?.id })
          });
        }

        if (data?.goalItemRemove?.tools) {
          store.modify({
            fields: {
              tools() {
                return data.goalItemRemove?.tools ?? null;
              }
            },
            id: store.identify({ ...goal })
          });
        }
      }
    }
  );

  return removeGoalItem;
};

export default useRemoveGoalItem;
